import axios from 'src/utils/axios';
import { URLS } from 'src/submodules/commons-system/constants/urls';
import authService from './authService';
import configService from './configService';
import * as yaml from 'js-yaml';
import i18n from 'src/i18n';
import { forEach } from 'lodash';
import { orderIntegrationArray } from 'src/utils/common';

const STORAGE_KEYS = {
	TENANTS: 'tenants',
	CURRENT_TENANT: 'currentTenant',
	INTEGRATION_TYPE: 'integration',
	MEASURES_DEFINITION: 'measuresDefinition'
};

let logoCache = {};

class TenatService {
	setTenants(t) {
		localStorage.setItem(STORAGE_KEYS.TENANTS, JSON.stringify(t || null));
		// AGGIUNGI CURRENT TENANT AD HEADER "X-SCF-Tenant"
		let currentTenant = tenantsService.getCurrentTenant();

		if (currentTenant) {
			axios.defaults.headers.common['X-SCF-Tenant'] = currentTenant?.id || null;
		}
	}

	setIntegration(t) {
		const integrationSorted = orderIntegrationArray(t);
		sessionStorage.setItem(
			STORAGE_KEYS.INTEGRATION_TYPE,
			JSON.stringify(integrationSorted || null)
		);
		integrationSorted.forEach(integration => {
			if (
				integration?.config_yaml !== undefined &&
				integration?.config_yaml !== null &&
				integration?.config_yaml !== ''
			) {
				const rawYaml = integration?.config_yaml.replace(/\r\n/g, '\n');
				let configObject;
				try {
					let yamlObj = yaml.load(rawYaml);
					configObject = {
						...yamlObj,
						id_integration: integration?.id_integration
					};
					sessionStorage.setItem(
						`${configObject?.id}_config_yaml`,
						JSON.stringify(configObject || null)
					);
				} catch (e) {
					console.error('Errore nel parsing YAML:', e.message);
				}
			}
			if (
				integration?.measures_yaml !== undefined &&
				integration?.measures_yaml !== null &&
				integration?.measures_yaml !== ''
			) {
				const rawMeasuresYaml = integration?.measures_yaml?.replace(
					/\r\n/g,
					'\n'
				);
				let configObject;
				try {
					configObject = yaml.load(rawMeasuresYaml);
					sessionStorage.setItem(
						`${configObject?.id}_measures_yaml`,
						JSON.stringify(configObject || null)
					);
				} catch (e) {
					console.error('Errore nel parsing YAML:', e.message);
				}
			}
			if (
				integration?.dashboard_yaml !== undefined &&
				integration?.dashboard_yaml !== null &&
				integration?.dashboard_yaml !== ''
			) {
				const rawYaml = integration?.dashboard_yaml.replace(/\r\n/g, '\n');
				let configObject;
				try {
					let yamlObj = yaml.load(rawYaml);
					configObject = {
						...yamlObj,
						id_integration: integration?.id_integration
					};
					sessionStorage.setItem(
						`${configObject?.id}_dashboard_yaml`,
						JSON.stringify(configObject || null)
					);
				} catch (e) {
					console.error('Errore nel parsing YAML:', e.message);
				}
			}
			if (
				integration?.translation_yaml !== undefined &&
				integration?.translation_yaml !== null &&
				integration?.translation_yaml !== ''
			) {
				const rawTranslationYaml = integration?.translation_yaml?.replace(
					/\r\n/g,
					'\n'
				);
				let configObject;
				try {
					configObject = yaml.load(rawTranslationYaml);
					const user_translation = configObject;
					const itTranslations = {};
					const enTranslations = {};

					const vv = user_translation?.translate?.forEach((tt, index) => {
						const key = String(tt.key).trim();
						if (key) {
							itTranslations[key] = tt.it || '';
							enTranslations[key] = tt.en || '';
						}
						return null;
					});
					i18n.addResourceBundle(
						'it-IT',
						'translations',
						itTranslations,
						true,
						true
					);
					i18n.addResourceBundle(
						'en-EN',
						'translations',
						enTranslations,
						true,
						true
					);
				} catch (e) {
					console.error('Errore nel parsing YAML:', e.message);
				}
			}
		});
	}

	getIntegration() {
		if (sessionStorage.getItem(STORAGE_KEYS.INTEGRATION_TYPE) !== null) {
			return JSON.parse(sessionStorage.getItem(STORAGE_KEYS.INTEGRATION_TYPE));
		} else {
			return null;
		}
	}

	getConfYaml(id) {
		return JSON.parse(sessionStorage.getItem(`${id}_config_yaml`));
	}

	getDashYaml(id) {
		return JSON.parse(sessionStorage.getItem(`${id}_dashboard_yaml`));
	}

	getMeasuresYaml(id) {
		return JSON.parse(sessionStorage.getItem(`${id}_measures_yaml`));
	}

	setMeasuresDefinition(t) {
		localStorage.setItem(
			STORAGE_KEYS.MEASURES_DEFINITION,
			JSON.stringify(t || null)
		);
	}

	getMeasuresDefinition() {
		JSON.parse(localStorage.getItem(STORAGE_KEYS.MEASURES_DEFINITION));
	}

	getTenants() {
		return JSON.parse(localStorage.getItem(STORAGE_KEYS.TENANTS));
	}

	setCurrentTenant(t) {
		localStorage.setItem(STORAGE_KEYS.CURRENT_TENANT, JSON.stringify(t));
		authService.saveCookies(STORAGE_KEYS.CURRENT_TENANT, JSON.stringify(t));
		window.location.reload();
	}

	getCurrentTenant() {
		let tenants = this.getTenants();
		let currentFromCookie = authService.getCookies(STORAGE_KEYS.CURRENT_TENANT);
		let current = JSON.parse(localStorage.getItem(STORAGE_KEYS.CURRENT_TENANT));
		if (currentFromCookie) {
			current = JSON.parse(currentFromCookie);
		}
		if (current) return current;

		if (tenants && tenants?.length > 0) {
			current = tenants[0];
			localStorage.setItem(
				STORAGE_KEYS.CURRENT_TENANT,
				JSON.stringify(tenants[0])
			);

			return current;
		}
	}

	clearStorage() {
		localStorage.removeItem(STORAGE_KEYS.TENANTS);
		localStorage.removeItem(STORAGE_KEYS.CURRENT_TENANT);
		delete axios.defaults.headers.common['X-SCF-Tenant'];
	}

	getLogo(size) {
		let defaultLogo = '/static/images/logo-ohm.png';
		let tenant = this.getCurrentTenant();
		let token = authService.getAccessToken();

		const cacheKey = `${tenant?.id}-${size}`;

		if (logoCache[cacheKey]) {
			return Promise.resolve(logoCache[cacheKey]);
		}

		if (tenant && token) {
			const url =
				size === 'large'
					? `${URLS.TENANTS}/${tenant.id}/logoLarge`
					: `${URLS.TENANTS}/${tenant.id}/logoSmall`;

			return axios({
				method: 'GET',
				url: url,
				responseType: 'blob',
				headers: {
					Authorization: `Bearer ${token}`
				}
			})
				.then(res => {
					const url =
						res?.data?.size > 0
							? window.URL.createObjectURL(new Blob([res.data]))
							: defaultLogo;
					logoCache[cacheKey] = url;
					const encode = btoa(JSON.stringify(url));
					localStorage.setItem('LOGO', encode);
					return url;
				})
				.catch(() => defaultLogo);
		} else {
			let conf = configService.getConfigByKey();
			const icon = conf?.appIcon || defaultLogo;
			logoCache[cacheKey] = icon;
			return Promise.resolve(icon);
		}
	}

	handleTenant() {
		const params = new URLSearchParams(window.location.search);
		const tenant = params.get('tenant');
		if (tenant) {
			console.log('tenant params url');
			const tenants = this.getTenants();
			const currentTenantNew = tenants.filter(t => t.id == tenant)[0];
			localStorage.setItem(STORAGE_KEYS.CURRENT_TENANT, JSON.stringify(currentTenantNew));
			authService.saveCookies(STORAGE_KEYS.CURRENT_TENANT, JSON.stringify(currentTenantNew));
			axios.defaults.headers.common['X-SCF-Tenant'] = currentTenantNew?.id || null;
		}
	}
}

const tenantsService = new TenatService();

export default tenantsService;
